import { useEffect, useState } from 'react';

/**
 * Tracks whether any lists of any type are associated with the project.
 * Used to distinguish between empty states for the following cases:
 * 1. projects with no existing lists
 * 2. projects with associated lists, but no relevant matches to display based
 *    on the users selected list type and/or search terms.
 */
export const useCheckListsExist = (count?: number) => {
  const [listsExist, setListsExist] = useState(false);

  useEffect(() => {
    if (count && count > 0 && !listsExist) {
      setListsExist(true);
    }
  }, [count]);

  return listsExist;
};
